import { useState, useEffect } from 'react';
import io from 'socket.io-client';
import axiosExpress from '../services/axiosExpress';

const socket = io('http://localhost:7070');

export default function NotificationBell({ userId }) {
    const [notifications, setNotifications] = useState([]);
    const [showDropdown, setShowDropdown] = useState(false);
    const [unreadCount, setUnreadCount] = useState(0);

    useEffect(() => {
        if (!userId) return;

        // Join user room for real-time notifications
        socket.emit('joinUser', { userId });
        // console.log(`Joined notification room: user_${userId}`);
        // Fetch existing notifications
        fetchNotifications();

        // Listen for new notifications
        socket.on('notification', (newNotification) => {
            setNotifications(prev => [newNotification, ...prev]);
            setUnreadCount(prev => prev + 1);
        });

        return () => socket.off('notification');
    }, [userId]);

    const fetchNotifications = async () => {
        try {
            const res = await axiosExpress.get(`/api/notifications/${userId}`);
            setNotifications(res.data);
            setUnreadCount(res.data.filter(n => !n.IsRead).length);
        } catch (err) {
            console.error(err);
        }
    };

    const markAsRead = async (id) => {
        try {
            await axiosExpress.put(`/api/notifications/${id}/read`);
            setNotifications(prev => prev.map(n => 
                n.Id === id ? { ...n, IsRead: true } : n
            ));
            setUnreadCount(prev => Math.max(0, prev - 1));
        } catch (err) {
            console.error(err);
        }
    };

    // console.log(notifications)
    return (
        <div className="relative">
            <button
                onClick={() => setShowDropdown(!showDropdown)}
                className="cursor-pointer relative p-2 hover:bg-zinc-800 rounded-2xl transition-colors"
            >
                <span className="text-xl">🛎️</span>
                {unreadCount > 0 && (
                    <span className="absolute top-1 right-1 bg-red-500 text-white text-[10px] font-bold w-5 h-5 flex items-center justify-center rounded-full">
                        {unreadCount}
                    </span>
                )}
            </button>

            {showDropdown && (
                <div className="absolute right-0 mt-2 w-96 bg-zinc-900 border border-zinc-700 rounded-3xl shadow-2xl z-50 max-h-[70vh] overflow-hidden">
                    <div className="p-4 border-b border-zinc-700 flex justify-between items-center">
                        <h3 className="font-semibold">Notifications</h3>
                        <button onClick={() => setShowDropdown(false)} className="cursor-pointer text-zinc-400 hover:text-white">✕</button>
                    </div>

                    <div className="max-h-[60vh] overflow-y-auto custom-scrollbar">
                        {notifications.length === 0 ? (
                            <div className="p-8 text-center text-zinc-400">No notifications yet</div>
                        ) : (
                            notifications.map((notif) => (
                                <div
                                    key={notif.Id}
                                    onClick={() => markAsRead(notif.Id)}
                                    className={`p-4 border-b border-zinc-800 hover:bg-zinc-800 cursor-pointer transition-colors ${!notif.IsRead ? 'bg-zinc-800/50' : ''}`}
                                >
                                    <div className="font-medium">{notif.Title}</div>
                                    <p className="text-sm text-zinc-400 mt-1">{notif.Message}</p>
                                    <div className="text-xs text-zinc-500 mt-2">
                                        {new Date(notif.CreatedAt).toLocaleDateString()}
                                    </div>
                                </div>
                            ))
                        )}
                    </div>
                </div>
            )}
        </div>
    );
}